/**
 * @ngdoc service
 * @name contacts.workflows:doContactShipping
 *
 * @description
 *
 */
angular
    .module('festzelt-os.contacts')
    .factory('doContactShipping', [
        'ContactActionsService',
        doContactShipping
    ]);

function doContactShipping(ContactActionsService) {
    return {
        key: 'do-contact-shipping',
        title: 'Ship things',
        level: 'highlight',
        icon: 'envelope-square',
        order: 100,
        action(contact) {
            return ContactActionsService.startShippingWorkflow(contact);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/detailed-view/do-shipping.js